import _range from 'lodash/range';

import { freezeBodyScroll, setCookie, unFreezeBodyScroll } from '../../utils';
import { RBFormatFields } from '../../utils/constant';

const DLP_ACTION_TYPES = {
  OPEN_DLP: 'OPEN_DLP',
  ERROR_DLP: 'ERROR_DLP',
  SUCCESS_DLP: 'SUCCESS_DLP',
  CLOSE_DLP: 'CLOSE_DLP',
  HIDE_DLP: 'HIDE_DLP',
  UNHIDE_DLP: 'UNHIDE_DLP',
};

export const ACTION_TYPES = {
  OPEN_LOGIN: 'OPEN_LOGIN',
  CLOSE_LOGIN: 'CLOSE_LOGIN',
  OPEN_SIGNUP: 'OPEN_SIGNUP',
  ONE_TAP_INIT: 'ONE_TAP_INIT',
  OPEN_ONE_TAP: 'OPEN_ONE_TAP',
  CLOSE_SIGNUP: 'CLOSE_SIGNUP',
  OPEN_SHARE: 'OPEN_SHARE',
  CLOSE_SHARE: 'CLOSE_SHARE',
  OPEN_POST_APPLY_UX_POPUP: 'OPEN_POST_APPLY_UX_POPUP',
  CLOSE_POST_APPLY_UX_POPUP: 'CLOSE_POST_APPLY_UX_POPUP',
  OPEN_LOCATION_INPUT_POPUP: 'OPEN_LOCATION_INPUT_POPUP',
  CLOSE_LOCATION_INPUT_POPUP: 'CLOSE_LOCATION_INPUT_POPUP',
  OPEN_POST_SIGNUP_SURVEY_POPUP: 'OPEN_POST_SIGNUP_SURVEY_POPUP',
  CLOSE_POST_SIGNUP_SURVEY_POPUP: 'CLOSE_POST_SIGNUP_SURVEY_POPUP',
  UPDATE_SURVEY_STEP: 'UPDATE_SURVEY_STEP',
  UPDATE_ANSWER: 'UPDATE_ANSWER_BY_KEY',
  UPDATE_SKIP_QUESTION: 'UPDATE_SKIP_QUESTION',
  UPDATE_ERROR: 'UPDATE_ERROR_BY_KEY',
  SEND_SURVEY_RESPONSE: 'SEND_SURVEY_RESPONSE',
  ...DLP_ACTION_TYPES,
  SHOW_COMPANY_REVIEW_CARD: 'SHOW_COMPANY_REVIEW_CARD',
  UPDATE_COMPANY_REVIEW_CARD_RATING: 'UPDATE_COMPANY_REVIEW_CARD_RATING',
  UPDATE_COMPANY_REVIEW_CARD_SOURCE: 'UPDATE_COMPANY_REVIEW_CARD_SOURCE',
  ADD_COMPANY_TO_FAVOURITE_IN_QUEUE: 'ADD_COMPANY_TO_FAVOURITE_IN_QUEUE',
  JOB_EASY_APPLY_OPEN: 'JOB_EASY_APPLY_OPEN',
  JOB_EASY_APPLY_CLOSE: 'JOB_EASY_APPLY_CLOSE',
  INIT_SURVEY_FULL_PAGE: 'INIT_SURVEY_FULL_PAGE',

  JOB_APPLY_SUCESS_NOTIFICATION: 'JOB_APPLY_SUCESS_NOTIFICATION',

  ADVICE_ARTICLE_POPUP_OPEN: 'ADVICE_ARTICLE_POPUP_OPEN',
  ADVICE_ARTICLE_POPUP_CLOSE: 'ADVICE_ARTICLE_POPUP_CLOSE',

  SESSION_TIMER_SIGNUP_OPEN: 'SESSION_TIMER_SIGNUP_OPEN',
  SESSION_TIMER_SIGNUP_CLOSE: 'SESSION_TIMER_SIGNUP_CLOSE',

  SESSION_CONDITIONAL_SIGNUP_VALIDATE: 'SESSION_CONDITIONAL_SIGNUP_VALIDATE',
  SESSION_CONDITIONAL_SIGNUP_OPEN: 'SESSION_CONDITIONAL_SIGNUP_OPEN',
  SESSION_CONDITIONAL_SIGNUP_COUNTER: 'SESSION_CONDITIONAL_SIGNUP_COUNTER',
  SESSION_CONDITIONAL_SIGNUP_CLOSE: 'SESSION_CONDITIONAL_SIGNUP_CLOSE',

  GATED_SIGNUP_OPEN: 'GATED_SIGNUP_OPEN',
  GATED_SIGNUP_CLOSE: 'GATED_SIGNUP_CLOSE',

  EMBED_WIDGET_OPEN: 'EMBED_WIDGET_OPEN',
  EMBED_WIDGET_CLOSE: 'EMBED_WIDGET_CLOSE',

  SHARE_MODAl_REVIEW_URL: 'SHARE_MODAl_REVIEW_URL',

  SIGNUP_RECAPTCHA_OPEN: 'SIGNUP_RECAPTCHA_OPEN',
  SIGNUP_RECAPTCHA_CLOSE: 'SIGNUP_RECAPTCHA_CLOSE',

  COLLEGE_POPUP_OPEN: 'COLLEGE_POPUP_OPEN',
  COLLEGE_POPUP_CLOSE: 'COLLEGE_POPUP_CLOSE',
  COLLEGE_POPUP_SUCCESS: 'COLLEGE_POPUP_SUCCESS',

  MORE_INFO_CONFIRM_MODAL_OPEN: 'MORE_INFO_CONFIRM_MODAL_OPEN',
  MORE_INFO_CONFIRM_MODAL_CLOSE: 'MORE_INFO_CONFIRM_MODAL_CLOSE',
  MORE_INFO_CONFIRM_MODAL_CONFIRM: 'MORE_INFO_CONFIRM_MODAL_CONFIRM',

  SHOW_CUSTOM_NOTIFICATION_PROMPT: 'SHOW_CUSTOM_NOTIFICATION_PROMPT',
  HIDE_CUSTOM_NOTIFICATION_PROMPT: 'HIDE_CUSTOM_NOTIFICATION_PROMPT',

  SHOW_RB_TEMPLATES_MODAL: 'SHOW_RB_TEMPLATES_MODAL',
  HIDE_RB_TEMPLATES_MODAL: 'HIDE_RB_TEMPLATES_MODAL',

  SHOW_RB_DELETE_POPUP: 'SHOW_RB_DELETE_POPUP',
  HIDE_RB_DELETE_POPUP: 'HIDE_RB_DELETE_POPUP',

  SHOW_RB_SUBSCRIPTION_MODAL: 'SHOW_RB_SUBSCRIPTION_MODAL',
  HIDE_RB_SUBSCRIPTION_MODAL: 'HIDE_RB_SUBSCRIPTION_MODAL',

  TOGGLE_RB_FORMAT_DRAWER: 'TOGGLE_RB_FORMAT_DRAWER',
  CHANGE_RB_FORMAT_SETTINGS: 'CHANGE_RB_FORMAT_SETTINGS',

  SHOW_RESET_PASSWORD_MODAL: 'SHOW_RESET_PASSWORD_MODAL',
  HIDE_RESET_PASSWORD_MODAL: 'HIDE_RESET_PASSWORD_MODAL',

  SHOW_JOB_ALERT_POPUP: 'SHOW_JOB_ALERT_POPUP',
  HIDE_JOB_ALERT_POPUP: 'HIDE_JOB_ALERT_POPUP',

  EXIT_INTENT_POPUP_OPEN: 'EXIT_INTENT_POPUP_OPEN',
  EXIT_INTENT_POPUP_CLOSE: 'EXIT_INTENT_POPUP_CLOSE',
};

const InitialLogin = {
  open: false,
  signUpSource: '',
  triggeredBy: 'header',
  /*
        header: modal opened from header button default
        card: modal opened from job card with save/dismiss,
        job: modal opened from job detail/popup with save/dismiss
        company: modal opened from company when adding to favourite
    */
  isSave: false,
  // user is saving particular job
  isDismiss: false,
  // user adds company to favorite
  isAddCompanyToFavouriteModal: false,
  // user follows the company
  isFollowCompanyModal: false,
  // user is adding job to favourite
  isUnlockContent: false,
  isPostApplySignup: false,
  isApplyNonCustomerJob: false,
  bufferedJob: {},
  bufferedContainerTitle: '',
};

export const InitialSignUp = {
  survey_step: '',
  // survey questions
  questionList: [], // order by orderNo
  orderQNameList: [], // orderBy question.qName
  skipQuestion: [],
  qListLength: 0,
  hasReviewForm: false,
  lastTwoQuestionNumber: null,
  oneTapSignUp: false,
  direction: 'ltr', // animation direction
  survey: '',
  surveyId: null,
  utm_campaign: '',
  questionId: '',
  surveyStartTimeStamp: Date.now(),
  timestamp: Date.now(),
  surveyFlow: 'surveyPopup',
  surveyStep: 1,
  entryPoint: '',

  // answer given by use and error
  answers: {},
  errors: {},
};
const InitialOneTapSignUp = {
  survey_step: '',
  // survey questions
  questionList: [], // order by orderNo
  orderQNameList: [], // orderBy question.qName
  skipQuestion: [],
  qListLength: 0,
  hasReviewForm: false,
  lastTwoQuestionNumber: null,
  oneTapSignUp: true,
  direction: 'ltr', // animation direction
  survey: '',
  surveyId: null,
  utm_campaign: '',
  questionId: '',
  surveyStartTimeStamp: Date.now(),
  timestamp: Date.now(),
  surveyFlow: 'surveyPopup',
  surveyStep: 1,
  entryPoint: '',

  // answer given by use and error
  answers: {},
  errors: {},
};

const initialLocationInputPopup = {
  open: false,
  purpose: null,
};

const initialPostSignUpSurveyPopup = {
  open: false,
};

const initialSessionTimerSignup = {
  open: false,
};

export const initialSessionConditionalSignup = {
  open: false,
  actionDispatchCounter: 0,
  isValidToTrigger: true,
  entryPoint: '',
};

const initialGatedSignup = {
  open: false,
};

const initialDLPState = {
  open: false,
  loading: false,
  error: null,
  isPopUp: true, // DLP is opened as popup
  url: '', // dlp url
  dlpDetail: null, // null or dlpDetail
  companyInfo: null,
  hidden: false, // hide from ui but keep open,
};

const InitialShare = {
  open: false,
};

export const initialEmbedWidget = {
  open: false,
  type: null,
  url: null,
  utmParams: '',
  openButtonRef: {},
};

const initialSignupRecaptcha = {
  open: false,
};

const resumeBuilderModals = {
  templates: false,
  delete: false,
  subscription: false,
  resetPassword: false,
};

const jobAlert = {
  open: false,
};

const rbFormatDrawer = {
  open: false,
  formatSettings: {
    [RBFormatFields.TEXT_SIZE.value]: {
      step: 1,
      value: 3,
      change: 0,
      options: _range(0, 8, 1),
    },
    [RBFormatFields.LINE_SPACING.value]: {
      step: 1,
      value: 3,
      change: 0,
      options: _range(0, 8, 1),
    },
    [RBFormatFields.SECTION_SPACING.value]: {
      step: 6,
      value: 24,
      change: 0,
      options: _range(0, 49, 6),
    },
    [RBFormatFields.COLOR.value]: {
      value: '#3174EE',
      change: '',
      options: [
        '#3174EE',
        '#009688',
        '#4CAF50',
        '#FF9800',
        '#FF5722',
        '#9C27B0',
        '#673AB7',
        '#607D8B',
        '#9E9E9E',
      ],
    },
  },
};

const initialExitIntentPopup = {
  open: false,
};

const initialState = {
  login: InitialLogin,
  locationInputPopup: initialLocationInputPopup,
  postSignUpSurveyPopup: initialPostSignUpSurveyPopup,
  customNotificationPrompt: {
    open: false,
  },
  signUp: {
    open: false,
    // survey Controller Detail
    ...InitialSignUp,
  },
  oneTapSignUp: {
    open: false,
    // survey Controller Detail
    ...InitialOneTapSignUp,
  },
  sessionTimerSignup: initialSessionTimerSignup,
  sessionConditionalSignup: initialSessionConditionalSignup,
  gatedSignup: initialGatedSignup,

  dlp: {
    ...initialDLPState,
  },
  share: InitialShare,
  easyApply: {
    open: false,
  },
  // default advice article conent inside popup modals
  adviceArticlePopup: {
    articlePopupOpen: false,
    article: null,
  },

  postApplyUX: {
    open: false,
  },

  embedWidget: initialEmbedWidget,

  signupRecaptcha: initialSignupRecaptcha,

  showCompanyReviewCard: false,
  addCompanyToFavouriteInQueue: {},
  showEasyApplySuccessMessage: false,
  rating: null,
  companyReviewCardSource: '',
  shareModalReviewUrl: '',
  surveyFullPage: false,
  resumeBuilderModals,
  jobAlert,
  rbFormatDrawer,
  exitIntentPopup: initialExitIntentPopup,
  oneTapInit: false,
};

const Modals = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_LOGIN:
      return {
        ...state,
        login: {
          ...state.login,
          ...action.payload,
          open: true,
        },
      };
    case ACTION_TYPES.CLOSE_LOGIN:
      return {
        ...state,
        login: InitialLogin,
      };
    case ACTION_TYPES.OPEN_POST_APPLY_UX_POPUP:{
      const { job, companyInfo } = action.payload;
      if (!state.dlp.open) freezeBodyScroll();
      return {
        ...state,
        postApplyUX: {
          job,
          open: true,
          companyInfo,
        },
      };
    }
    case ACTION_TYPES.CLOSE_POST_APPLY_UX_POPUP:
      if (!state.dlp.open) unFreezeBodyScroll();
      return {
        ...state,
        postApplyUX: {
          open: false,
        },
      };
    case ACTION_TYPES.OPEN_SIGNUP:
      // disable Body Scroll
      freezeBodyScroll();
      return {
        ...state,
        easyApply: {
          ...state.easyApply,
          open: false,
        },
        signUp: {
          ...state.signUp,
          ...action.payload,
          open: true,
          oneTapSignUp: false,
        },
      };
    case ACTION_TYPES.OPEN_ONE_TAP:
      return {
        ...state,
        signUp: {
          ...state.signUp,
          ...action.payload,
          open: true,
          oneTapSignUp: true,
        },
      };
    case ACTION_TYPES.ONE_TAP_INIT:
      return {
        ...state,
        oneTapInit: true,
      };
    case ACTION_TYPES.CLOSE_SIGNUP:
      // if one tap close add cookies
      if (state.signUp.survey === '039') {
        const initialCookie = {
          item: '_zippia-onetap-closed',
          expiredays: 1,
          path: '/',
        };
        setCookie({
          ...initialCookie,
          value: true,
        });
      } else {
        // enable body scroll
        unFreezeBodyScroll();
      }
      return {
        ...state,
        signUp: {
          // existing state
          ...state.signUp,
          // set open to false
          survey: '',
          skipQuestion: [],
          open: false,
          entryPoint: '',
          answers: {},
          errors: {},
        },
      };
    case ACTION_TYPES.SESSION_TIMER_SIGNUP_OPEN:
      return {
        ...state,
        sessionTimerSignup: {
          ...action.payload,
          open: true,
        },
      };
    case ACTION_TYPES.SESSION_TIMER_SIGNUP_CLOSE:
      return {
        ...state,
        sessionTimerSignup: {
          open: false,
        },
      };
    case ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_OPEN:
      return {
        ...state,
        sessionConditionalSignup: {
          ...state.sessionConditionalSignup,
          ...action.payload,
          open: true,
          isValidToTrigger: false,
        },
      };
    case ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_COUNTER:
      return {
        ...state,
        sessionConditionalSignup: {
          ...state.sessionConditionalSignup,
          ...action.payload,
          actionDispatchCounter: state.sessionConditionalSignup.actionDispatchCounter + 1,
        },
      };
    case ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_VALIDATE:
      return {
        ...state,
        sessionConditionalSignup: {
          ...state.sessionConditionalSignup,
          isValidToTrigger: action.payload,
        },
      };
    case ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_CLOSE:
      return {
        ...state,
        sessionConditionalSignup: {
          ...state.sessionConditionalSignup,
          ...action.payload,
          open: false,
          entryPoint: '',
        },
      };
    case ACTION_TYPES.GATED_SIGNUP_OPEN:
      return {
        ...state,
        gatedSignup: {
          ...action.payload,
          open: true,
        },
      };
    case ACTION_TYPES.GATED_SIGNUP_CLOSE:
      return {
        ...state,
        gatedSignup: {
          open: false,
        },
      };
    case ACTION_TYPES.UPDATE_SURVEY_STEP:
      // surveyStep && survey_step
      return {
        ...state,
        signUp: {
          ...state.signUp,
          ...action.payload,
        },
      };
    case ACTION_TYPES.UPDATE_ANSWER:
      return {
        ...state,
        signUp: {
          ...state.signUp,
          answers: {
            ...state.signUp.answers,
            [state.signUp.survey_step]: action.payload,
          },
        },
      };
    case ACTION_TYPES.UPDATE_SKIP_QUESTION:
      return {
        ...state,
        signUp: {
          ...state.signUp,
          skipQuestion: action.payload,
        },
      };
    case ACTION_TYPES.UPDATE_ERROR:
      return {
        ...state,
        signUp: {
          ...state.signUp,
          errors: {
            ...state.signUp.errors,
            [state.signUp.survey_step]: action.payload,
          },
        },
      };
    case ACTION_TYPES.OPEN_DLP: {
      return {
        ...state,
        dlp: {
          ...state.dlp,
          loading: true,
          open: true,
          error: null,
        },
        postApplyUX: {
          ...state.postApplyUX,
          open: false,
        },
      };
    }
    case ACTION_TYPES.SUCCESS_DLP: {
      return {
        ...state,
        dlp: {
          ...state.dlp,
          loading: false,
          error: null,
          ...action.payload,
        },
      };
    }
    case ACTION_TYPES.ERROR_DLP: {
      return {
        ...state,
        dlp: {
          ...state.dlp,
          ...action.payload,
          loading: false,
          open: false,
        },
      };
    }
    case ACTION_TYPES.CLOSE_DLP: {
      return {
        ...state,
        dlp: initialDLPState,
        postApplyUX: {
          ...state.postApplyUX,
          open: !!state.postApplyUX.job,
        },
      };
    }
    case ACTION_TYPES.HIDE_DLP: {
      return {
        ...state,
        dlp: {
          ...state.dlp,
          hidden: true,
        },
      };
    }
    case ACTION_TYPES.UNHIDE_DLP: {
      return {
        ...state,
        dlp: {
          ...state.dlp,
          hidden: false,
        },
      };
    }
    case ACTION_TYPES.OPEN_SHARE:
      return {
        ...state,
        share: {
          ...state.share,
          ...action.payload,
          open: true,
        },
      };
    case ACTION_TYPES.CLOSE_SHARE:
      return {
        ...state,
        share: InitialShare,
      };
    case ACTION_TYPES.SHOW_COMPANY_REVIEW_CARD:{
      const showCompanyReviewCard = action.payload;
      if (showCompanyReviewCard) {
        freezeBodyScroll();
      } else {
        unFreezeBodyScroll();
      }
      return {
        ...state,
        showCompanyReviewCard,
      };
    }
    case ACTION_TYPES.ADD_COMPANY_TO_FAVOURITE_IN_QUEUE:
      return {
        ...state,
        addCompanyToFavouriteInQueue: action.payload,
      };
    case ACTION_TYPES.JOB_EASY_APPLY_OPEN: {
      return {
        ...state,
        easyApply: {
          ...action.payload,
          open: true,
        },
      };
    }
    case ACTION_TYPES.JOB_EASY_APPLY_CLOSE: {
      return {
        ...state,
        easyApply: {
          open: false,
        },
      };
    }
    case ACTION_TYPES.JOB_APPLY_SUCESS_NOTIFICATION: {
      return {
        ...state,
        showEasyApplySuccessMessage: action.payload,
      };
    }
    case ACTION_TYPES.INIT_SURVEY_FULL_PAGE: {
      // disable Body Scroll
      freezeBodyScroll();
      return {
        ...state,
        signUp: {
          ...state.signUp,
          ...action.payload,
          open: true,
          surveyFullPage: true,
        },
      };
    }
    case ACTION_TYPES.UPDATE_COMPANY_REVIEW_CARD_SOURCE: {
      return {
        ...state,
        companyReviewCardSource: action.payload,
      };
    }
    case ACTION_TYPES.UPDATE_COMPANY_REVIEW_CARD_RATING:
      return {
        ...state,
        rating: action.payload,
      };
    case ACTION_TYPES.ADVICE_ARTICLE_POPUP_OPEN: {
      return {
        ...state,
        adviceArticlePopup: {
          articlePopupOpen: true,
          article: action.payload,
        },
      };
    }
    case ACTION_TYPES.ADVICE_ARTICLE_POPUP_CLOSE: {
      return {
        ...state,
        adviceArticlePopup: {
          articlePopupOpen: false,
          article: null,
        },
      };
    }
    case ACTION_TYPES.EMBED_WIDGET_OPEN: {
      return {
        ...state,
        embedWidget: {
          ...action.payload,
          open: true,
        },
      };
    }
    case ACTION_TYPES.EMBED_WIDGET_CLOSE: {
      return {
        ...state,
        embedWidget: {
          ...action.payload,
          open: false,
        },
      };
    }
    case ACTION_TYPES.OPEN_LOCATION_INPUT_POPUP: {
      return {
        ...state,
        locationInputPopup: {
          open: true,
          purpose: action.payload.purpose,
        },
      };
    }
    case ACTION_TYPES.CLOSE_LOCATION_INPUT_POPUP: {
      return {
        ...state,
        locationInputPopup: {
          open: false,
          purpose: null,
        },
      };
    }
    case ACTION_TYPES.OPEN_POST_SIGNUP_SURVEY_POPUP: {
      return {
        ...state,
        postSignUpSurveyPopup: {
          open: true,
        },
      };
    }
    case ACTION_TYPES.CLOSE_POST_SIGNUP_SURVEY_POPUP: {
      return {
        ...state,
        postSignUpSurveyPopup: {
          open: false,
        },
      };
    }
    case ACTION_TYPES.SHARE_MODAl_REVIEW_URL:
      return {
        ...state,
        shareModalReviewUrl: action.payload.shareModalReviewUrl,
      };
    case ACTION_TYPES.SIGNUP_RECAPTCHA_OPEN: {
      return {
        ...state,
        signupRecaptcha: {
          ...action.payload,
          open: true,
        },
      };
    }
    case ACTION_TYPES.SIGNUP_RECAPTCHA_CLOSE: {
      return {
        ...state,
        signupRecaptcha: {
          ...action.payload,
          open: false,
        },
      };
    }

    case ACTION_TYPES.SHOW_CUSTOM_NOTIFICATION_PROMPT:
      return {
        ...state,
        customNotificationPrompt: {
          open: true,
        },
      };

    case ACTION_TYPES.HIDE_CUSTOM_NOTIFICATION_PROMPT:
      return {
        ...state,
        customNotificationPrompt: {
          open: false,
        },
      };

    case ACTION_TYPES.SHOW_RB_TEMPLATES_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          templates: true,
        },
      };

    case ACTION_TYPES.HIDE_RB_TEMPLATES_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          templates: false,
        },
      };

    case ACTION_TYPES.SHOW_RB_DELETE_POPUP:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          delete: true,
        },
      };

    case ACTION_TYPES.HIDE_RB_DELETE_POPUP:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          delete: false,
        },
      };

    case ACTION_TYPES.SHOW_RB_SUBSCRIPTION_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          subscription: true,
        },
      };

    case ACTION_TYPES.HIDE_RB_SUBSCRIPTION_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          subscription: false,
        },
      };

    case ACTION_TYPES.SHOW_RESET_PASSWORD_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          resetPassword: true,
        },
      };

    case ACTION_TYPES.HIDE_RESET_PASSWORD_MODAL:
      return {
        ...state,
        resumeBuilderModals: {
          ...state.resumeBuilderModals,
          resetPassword: false,
        },
      };

    case ACTION_TYPES.SHOW_JOB_ALERT_POPUP:
      return {
        ...state,
        jobAlert: {
          open: true,
        },
      };

    case ACTION_TYPES.HIDE_JOB_ALERT_POPUP:
      return {
        ...state,
        jobAlert: {
          open: false,
        },
      };

    case ACTION_TYPES.TOGGLE_RB_FORMAT_DRAWER:
      return {
        ...state,
        rbFormatDrawer: {
          ...state.rbFormatDrawer,
          open: !state.rbFormatDrawer.open,
        },
      };

    case ACTION_TYPES.CHANGE_RB_FORMAT_SETTINGS:{
      let formatSettings = { ...state.rbFormatDrawer.formatSettings };
      Object.keys(action.payload || {}).forEach((key) => {
        formatSettings = {
          ...formatSettings,
          [key]: {
            ...formatSettings[key],
            value: action.payload[key],
            change:
              key !== RBFormatFields.COLOR.value
                ? action.payload[key] - initialState.rbFormatDrawer.formatSettings[key].value
                : action.payload[key],
          },
        };
      });
      return {
        ...state,
        rbFormatDrawer: {
          ...state.rbFormatDrawer,
          formatSettings,
        },
      };
    }

    case ACTION_TYPES.EXIT_INTENT_POPUP_OPEN:
      return {
        ...state,
        exitIntentPopup: {
          ...state.exitIntentPopup,
          open: true,
        }
      };

    case ACTION_TYPES.EXIT_INTENT_POPUP_CLOSE:
      return {
        ...state,
        exitIntentPopup: {
          ...state.exitIntentPopup,
          open: false,
        }
      };

    default:
      return state;
  }
};
export default Modals;
